<!-- src/components/modal/email-label-modal.vue -->
<template>
  <div class="modal fade" id="email_label_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content border-0">
        <div class="modal-header bg-dark justify-content-between">
          <h6 class="modal-title text-white mb-0">
            <i class="ti ti-tag me-2"></i>Create Label
          </h6>
          <button
            type="button"
            class="btn-close custom-btn-close bg-transparent fs-16 text-white position-static"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <form @submit.prevent="submit">
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Label name</label>
              <input
                v-model.trim="form.name"
                type="text"
                class="form-control"
                placeholder="e.g. Projects"
                :disabled="saving"
                maxlength="40"
                required
              />
              <div class="form-text">Keep it short and clear.</div>
            </div>

            <div class="mb-2">
              <label class="form-label">Color</label>

              <div class="d-flex align-items-center gap-2 flex-wrap">
                <button
                  v-for="c in palette"
                  :key="c"
                  type="button"
                  class="dq-color"
                  :style="{ background: c }"
                  :class="{ active: form.color === c }"
                  :disabled="saving"
                  @click="form.color = c"
                ></button>

                <div class="ms-auto d-flex align-items-center gap-2">
                  <span class="text-muted small">Custom</span>
                  <input
                    type="color"
                    v-model="form.color"
                    class="form-control form-control-color"
                    :disabled="saving"
                    title="Pick color"
                    style="width: 44px; height: 34px"
                  />
                </div>
              </div>
            </div>

            <div class="mt-3 p-2 rounded border d-flex align-items-center">
              <span class="badge rounded-pill me-2" :style="previewStyle">
                <i class="ti ti-square me-1"></i>{{ form.name || "Label preview" }}
              </span>
              <span class="text-muted small">Preview</span>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-white"
              data-bs-dismiss="modal"
              :disabled="saving"
            >
              Cancel
            </button>

            <button type="submit" class="btn btn-primary" :disabled="saving || !canSubmit">
              <span v-if="saving" class="spinner-border spinner-border-sm me-2"></span>
              Create
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, reactive, ref } from "vue";
import { Modal } from "bootstrap";
import { useEmailStore } from "@/stores/emailStore";

const emailStore = useEmailStore();

const saving = ref(false);

const palette = [
  "#22c55e", // green
  "#f59e0b", // amber
  "#ef4444", // red
  "#3b82f6", // blue
  "#a855f7", // purple
  "#06b6d4", // cyan
  "#64748b", // slate
];

const form = reactive({
  name: "",
  color: "#3b82f6",
});

const canSubmit = computed(() => form.name.trim().length >= 2);

const previewStyle = computed(() => ({
  background: `${form.color}20`,
  color: form.color,
  border: `1px solid ${form.color}40`,
}));

function reset() {
  form.name = "";
  form.color = "#3b82f6";
}

function closeModal() {
  const el = document.getElementById("email_label_modal");
  const m = el ? Modal.getInstance(el) || new Modal(el) : null;
  m?.hide();
}

async function submit() {
  if (!canSubmit.value) return;

  saving.value = true;
  try {
    await emailStore.createLabel({
      name: form.name.trim(),
      color: form.color,
    });
    closeModal();
    reset();
  } finally {
    saving.value = false;
  }
}
</script>

<style scoped>
.dq-color {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: 2px solid transparent;
  outline: none;
  cursor: pointer;
}
.dq-color.active {
  border-color: #111827;
  box-shadow: 0 0 0 2px rgba(17, 24, 39, 0.12);
}
</style>
